import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function WhatsAppApiSuccessModal({ pin, phoneNumber, emailSent, onClose }) {
  const { t } = useTranslation('channels');
  const [copied, setCopied] = useState(false);

  if (!pin) return null;

  const handleCopy = async () => {
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(pin);
      } else {
        const ta = document.createElement('textarea');
        ta.value = pin;
        ta.setAttribute('readonly', '');
        ta.style.position = 'fixed';
        ta.style.top = '-1000px';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
      }
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (_) {
      // Silent — clipboard API can fail on insecure contexts
    }
  };

  return (
    <div
      role="dialog"
      aria-modal="true"
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0, 0, 0, 0.6)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        padding: 16,
      }}
    >
      <div
        style={{
          background: '#ffffff',
          borderRadius: 16,
          maxWidth: 480,
          width: '100%',
          maxHeight: '90vh',
          overflowY: 'auto',
          padding: 32,
          boxShadow: '0 20px 48px rgba(0, 0, 0, 0.2)',
          fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
          color: '#1a1a1a',
        }}
      >
        <div style={{ textAlign: 'center', marginBottom: 20 }}>
          <div
            aria-hidden="true"
            style={{
              width: 56,
              height: 56,
              borderRadius: '50%',
              background: '#ecfdf5',
              color: '#059669',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 28,
              lineHeight: 1,
            }}
          >
            🔒
          </div>
        </div>

        <h2
          style={{
            fontSize: 22,
            fontWeight: 600,
            textAlign: 'center',
            margin: '0 0 8px',
            color: '#0f172a',
          }}
        >
          {t('pinModal.title')}
        </h2>

        <p
          style={{
            fontSize: 14,
            lineHeight: 1.55,
            textAlign: 'center',
            color: '#52525b',
            margin: '0 0 24px',
          }}
        >
          {t('pinModal.subtitle', { phoneNumber })}
        </p>

        <div
          style={{
            background: '#f4f4f5',
            border: '2px solid #e4e4e7',
            borderRadius: 12,
            padding: 20,
            textAlign: 'center',
            marginBottom: 16,
          }}
        >
          <div
            style={{
              fontSize: 12,
              fontWeight: 500,
              color: '#71717a',
              textTransform: 'uppercase',
              letterSpacing: 1,
              marginBottom: 10,
            }}
          >
            {t('pinModal.yourPin')}
          </div>
          <div
            style={{
              fontSize: 40,
              fontWeight: 700,
              letterSpacing: 8,
              color: '#18181b',
              fontFamily: "'SF Mono', Menlo, Monaco, Consolas, monospace",
              marginBottom: 16,
              userSelect: 'all',
            }}
          >
            {pin}
          </div>
          <button
            type="button"
            onClick={handleCopy}
            style={{
              background: copied ? '#059669' : '#18181b',
              color: '#ffffff',
              border: 'none',
              padding: '10px 20px',
              borderRadius: 8,
              fontSize: 14,
              fontWeight: 500,
              cursor: 'pointer',
              transition: 'background 0.15s ease',
            }}
          >
            {copied ? t('pinModal.copiedBtn') : t('pinModal.copyBtn')}
          </button>
        </div>

        <div
          style={{
            background: '#fffbeb',
            border: '1px solid #fcd34d',
            borderRadius: 10,
            padding: 14,
            marginBottom: 16,
          }}
        >
          <div
            style={{
              fontSize: 13,
              fontWeight: 600,
              color: '#92400e',
              marginBottom: 4,
            }}
          >
            {t('pinModal.warningTitle')}
          </div>
          <div style={{ fontSize: 13, lineHeight: 1.5, color: '#92400e' }}>
            {t('pinModal.warningBody')}
          </div>
        </div>

        <div style={{ marginBottom: 16 }}>
          <div
            style={{
              fontSize: 13,
              fontWeight: 600,
              color: '#0f172a',
              marginBottom: 4,
            }}
          >
            {t('pinModal.purposeTitle')}
          </div>
          <div style={{ fontSize: 13, lineHeight: 1.55, color: '#52525b' }}>
            {t('pinModal.purposeBody')}
          </div>
        </div>

        {emailSent && (
          <div
            style={{
              background: '#ecfdf5',
              border: '1px solid #a7f3d0',
              borderRadius: 10,
              padding: 12,
              marginBottom: 16,
              fontSize: 13,
              color: '#065f46',
            }}
          >
            {t('pinModal.emailSent')}
          </div>
        )}

        <button
          type="button"
          onClick={onClose}
          style={{
            width: '100%',
            background: '#25D366',
            color: '#ffffff',
            border: 'none',
            padding: 14,
            borderRadius: 10,
            fontSize: 15,
            fontWeight: 600,
            cursor: 'pointer',
            marginTop: 8,
          }}
        >
          {t('pinModal.doneBtn')}
        </button>
      </div>
    </div>
  );
}
